<template>
  <div>
      <div class="panel">
          <h2>It looks like you have a custom theme</h2>
          <p>To change your current theme please contact us on support.</p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'CustomSkinMessage',
  data() {
    return {};
  }
};
</script>
